import { HelpLink } from 'elements/link/HelpLink'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const ProposalTemplateTitle = ({ record, translate, style }) => (
  <Typography textVariant="h5SemiBold" style={style}>
    {translate('Proposal Title')} - {record && record.title}
  </Typography>
)

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <Typography textVariant="body1" colorHex="#717171">
      {translate(
        'Create and edit a default proposal template, and create additional templates that can be applied on a per project basis from the Online Proposal page in the Projects zone. In creating a proposal template you can customise what information is shown to the customer, the sequence in which it is presented and how customers are able to interact with it. If you intend to share proposals via PDF, be sure to check out the PDF settings as well. You can also customise the proposal template in the Online Proposal page in the Projects zone.'
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12487725959951-How-to-create-your-proposal-template" />
    </Typography>
  )
}

export default {
  list: { lazy: () => import('./ProposalTemplates'), component: 'ProposalTemplateList' },
  create: { lazy: () => import('./ProposalTemplates'), component: 'ProposalTemplateCreate' },
  edit: { lazy: () => import('./ProposalTemplates'), component: 'ProposalTemplateEdit' },
  options: {
    create: {
      title: 'Create Proposal Template',
      subtitle: null,
      breadCrumb: 'Create Template',
    },
    list: {
      title: <Typography textVariant="h5SemiBold">My Proposal Templates List</Typography>,
      subtitle: <Subtitle />,
      breadCrumb: 'Proposal Templates',
    },
    edit: {
      title: <ProposalTemplateTitle />,
      subtitle: null,
      breadCrumb: 'Edit Template',
    },
  },
}
